class ProductCard extends HTMLElement {
  connectedCallback() {
    this.secondaryImage = this.querySelector('.product-card__image--secondary');
    this.link = this.querySelector('.product-card__link');
    if (!this.secondaryImage || !this.link) return;

    this.revealed = false;
    this.link.addEventListener('click', this.onLinkClick);
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.onLinkClick);
  }

  onLinkClick = (event) => {
    // Devices with a real hover-capable pointer already get the reveal via
    // CSS :hover — let that first click navigate straight through. Only
    // intercept where there's no hover to preview the second image first.
    if (window.matchMedia('(hover: hover)').matches) return;

    if (!this.revealed) {
      event.preventDefault();
      this.revealed = true;
      this.classList.add('product-card--revealed');
    }
  };
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
